// src/pages/MarketplaceIntegration/notificationService.js

// This service handles real-time notifications for marketplace events
// In a real implementation, this would use Firebase Cloud Messaging or similar

class NotificationService {
  constructor() {
    this.listeners = new Map();
    this.notificationHistory = [];
  }

  // Subscribe to notifications
  subscribe(eventType, callback) {
    if (!this.listeners.has(eventType)) {
      this.listeners.set(eventType, []);
    }
    
    const listeners = this.listeners.get(eventType);
    const listenerId = Date.now().toString() + Math.random().toString(36).substr(2, 9);
    listeners.push({ id: listenerId, callback });
    
    console.log(`Subscribed to ${eventType} notifications with ID: ${listenerId}`);
    return listenerId;
  }

  // Unsubscribe from notifications
  unsubscribe(eventType, listenerId) {
    if (!this.listeners.has(eventType)) return false;
    
    const listeners = this.listeners.get(eventType);
    const index = listeners.findIndex(listener => listener.id === listenerId);
    
    if (index !== -1) {
      listeners.splice(index, 1);
      console.log(`Unsubscribed from ${eventType} notifications with ID: ${listenerId}`);
      return true;
    }
    
    return false;
  }

  // Send a notification
  sendNotification(eventType, data) {
    // Add to history
    const notification = {
      id: Date.now().toString() + Math.random().toString(36).substr(2, 9),
      type: eventType,
      data,
      timestamp: new Date(),
      read: false
    };
    
    this.notificationHistory.push(notification);
    
    // Keep only last 100 notifications
    if (this.notificationHistory.length > 100) {
      this.notificationHistory.shift();
    }
    
    // Notify listeners
    if (this.listeners.has(eventType)) {
      const listeners = this.listeners.get(eventType);
      listeners.forEach(listener => {
        try {
          listener.callback(notification);
        } catch (error) {
          console.error('Error in notification callback:', error);
        }
      });
    }
    
    console.log(`Notification sent: ${eventType}`, data);
    return notification.id;
  }

  // Mark notification as read
  markAsRead(notificationId) {
    const notification = this.notificationHistory.find(n => n.id === notificationId);
    if (notification) {
      notification.read = true;
      return true;
    }
    return false;
  }

  // Get unread notifications
  getUnreadNotifications() {
    return this.notificationHistory.filter(n => !n.read);
  }

  // Get all notifications
  getAllNotifications() {
    return [...this.notificationHistory].reverse(); // Most recent first
  }

  // Clear notifications
  clearNotifications() {
    this.notificationHistory = [];
  }

  // Get notifications by type
  getNotificationsByType(type) {
    return this.notificationHistory.filter(n => n.type === type).reverse();
  }

  // Send specific marketplace notifications
  sendNewOrderNotification(marketplace, orderData) {
    return this.sendNotification('new_order', {
      marketplace,
      order: orderData,
      message: `Yeni sipariş ${marketplace} üzerinden alındı`
    });
  }

  sendStockSyncNotification(marketplace, productData, status) {
    return this.sendNotification('stock_sync', {
      marketplace,
      product: productData,
      status,
      message: `Stok senkronizasyonu ${status === 'success' ? 'başarılı' : 'başarısız'}: ${productData.name}`
    });
  }

  sendErrorNotification(marketplace, errorData) {
    return this.sendNotification('error', {
      marketplace,
      error: errorData,
      message: `Hata oluştu: ${errorData.message}`
    });
  }

  sendSyncCompleteNotification(marketplace, stats) {
    return this.sendNotification('sync_complete', {
      marketplace,
      stats,
      message: `Senkronizasyon tamamlandı: ${stats.updatedProducts} ürün güncellendi`
    });
  }
}

// Export singleton instance
const notificationService = new NotificationService();
export default notificationService;